/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import {
    Radio,
    RadioGroup,
    FormControl,
    FormLabel,
    FormControlLabel,
    FormHelperText,
    Box,
} from "@mui/material";

const RHFRadioGroup = ({ formData, control, values, isDisabled }) => {
    // Extract and map DataValues into options
    const options = formData?.DataValues?.split('|').map((item) => {
        const [value, label] = item.split(':');
        return { value, label };
    });

    // Generate validation rules dynamically
    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    const isReportGeneratedOn = formData?.ValueExpr === 'ReportGeneratedOn';

    const rawDefault = formData?.DefaultValues && Array.isArray(formData.DefaultValues) && formData.DefaultValues.length > 0
        ? formData.DefaultValues[0]
        : null;

    return (
        <FormControl
            component="fieldset"
            disabled={isDisabled}
            error={!!rules?.required}
            fullWidth
            sx={isReportGeneratedOn ? {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 2
            } : {}}
        >
            <FormLabel
                disabled={isDisabled}
                sx={{
                    fontSize: "14px",
                    mb: isReportGeneratedOn ? 0 : 1,
                    color: isDisabled ? 'text.disabled' : "black",
                    '&.Mui-focused': {
                        color: isDisabled ? 'text.disabled' : 'black'
                    },
                    '&.Mui-disabled': {
                        color: 'text.disabled',
                    }
                }}
            >
                <>
                    <span style={{ color: isDisabled ? 'rgba(0, 0, 0, 0.38)' : "black" }}>{formData?.LabelName || formData?.DisplayExpr}</span>
                    {rules?.required && (
                        <span style={{ color: isDisabled ? 'rgba(0, 0, 0, 0.38)' : "red", marginLeft: "2px" }}>*</span>
                    )}
                </>
            </FormLabel>

            <Controller
                name={formData?.ValueExpr}
                control={control}
                rules={rules}
                render={({ field, fieldState: { error } }) => {
                    // eslint-disable-next-line no-nested-ternary
                    const selectedValue = (field?.value !== undefined && field?.value !== null && field?.value !== '')
                        ? String(field.value)
                        : (rawDefault !== null && rawDefault !== undefined ? String(rawDefault) : '');

                    return (
                        <Box sx={isReportGeneratedOn ? { display: 'flex', alignItems: 'center', gap: 1 } : {}}>
                            <RadioGroup
                                {...field}
                                row
                                value={selectedValue}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    const numVal = Number(val);
                                    field.onChange(!Number.isNaN(numVal) && val !== '' ? numVal : val);
                                }}
                            >
                                {options?.map((option) => {
                                    const isRadioDisabled = isDisabled || (formData?.ValueExpr === 'SchemeBeneficiary' && values?.SchemeApplicable?.toString() === '1');
                                    return (
                                        <FormControlLabel
                                            key={option.value}
                                            value={String(option?.value) || null}
                                            disabled={isRadioDisabled}
                                            control={<Radio disabled={isRadioDisabled} style={{ transform: 'scale(0.6)' }} />}
                                            label={<span style={{ fontSize: "13px", color: isRadioDisabled ? 'rgba(0, 0, 0, 0.38)' : undefined }}>{option.label}</span>}
                                        />
                                    );
                                })}
                            </RadioGroup>
                            {error && (
                                <FormHelperText error sx={{ fontSize: "10px", color: "red !important" }}>
                                    {error.message}
                                </FormHelperText>
                            )}
                        </Box>
                    );
                }}
            />
        </FormControl>
    );
};

export default RHFRadioGroup;
